import React from "react";
import style from "./navbar.module.scss";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import BasicMenu from "../../commons/menu/BasicMenu";

function NavbarComponent({ items }) {
  return (
    <div className={style.container}>
      <div>
        <BasicMenu icon={<MenuRoundedIcon sx={{ fontSize: 45 }} />} />
      </div>
    </div>
  );
}

export default NavbarComponent;
